module.exports = __webpack_public_path__ + "static/media/06_720.593c7398.jpeg";